import React from 'react';

const defaultImpl = {};
export const InstrumentationContext = React.createContext(defaultImpl);
